<div class="balance-board-container">
	<div nz-row nzAlign="middle" nzJustify="space-between">
		<div nz-row nzAlign="middle">
			<div>
				<svg fill="none" height="40" viewBox="0 0 40 40" width="40" xmlns="http://www.w3.org/2000/svg">
					<rect fill="white" height="16.6883" width="17.318" x="11.5688" y="12.0159" />
					<path clip-rule="evenodd"
						d="M19.86 40H20.0029C29.2423 40 35.4337 38.0645 36.7196 36.8459C38.0769 35.6272 39.8629 29.2951 39.8629 20C39.8629 10.7049 38.0769 4.37276 36.7196 3.15412C35.4337 1.95938 29.2423 0.0238949 20.0029 0H19.86C10.6444 0.0238949 4.42921 1.95938 3.14331 3.15412C1.78597 4.37276 0 10.7049 0 20C0 29.319 1.78597 35.6272 3.14331 36.8459C4.42921 38.0406 10.6206 39.9761 19.86 40ZM28.3608 11.8518L29.1228 21.1947L29.6467 28.172H26.8368C25.6461 28.172 25.1461 27.6463 25.0508 26.356L24.646 17.7299H24.5984C24.265 18.9964 21.6456 25.3285 21.6456 25.3285H18.1927C18.1927 25.3285 15.5733 18.9008 15.3828 18.2317L15.2399 17.7299H15.1923C15.2637 18.8291 14.7874 26.356 14.7874 26.356C14.6922 27.6463 14.2159 28.172 13.0015 28.172H10.1915L10.8345 19.9522L11.5965 11.8518H16.2162L19.9072 20.0238H19.9548C20.2644 19.0442 23.7649 11.8518 23.7649 11.8518H28.3608Z"
						fill="#0361F0" fill-rule="evenodd" />
				</svg>
			</div>
			<div class="m-t-8 m-l-17">
				<div class="balance-board-acc-name">{{accountName}}</div>
				<div class="balance-board-acc-values m-t-4">Balance : <strong>N {{accountDetails?.balance}}</strong>
				</div>
				<div>Account No: <strong>{{accountDetails?.accountNo}}</strong></div>
			</div>
		</div>
		<div *ngIf="false" class="balance-board-acc-change addCursor">
			Change
		</div>
	</div>
</div>